import { MprcLink } from "components";
import { useMprcTheme } from "components/MprcThemeProvider";
import LibUtils from "lib/LibUtils";
import { useSession } from "providers/SessionProvider";
import { useModalUserProfile } from "providers/UserProfileProvider";
import * as React from "react";

interface IUserBasicInfo {
    userId: string;
    name: string;
    isSystemUser?: boolean;
}

interface IProps {
    user: IUserBasicInfo;
}

export const MprcUserProfileLink: React.FC<IProps> = (props) => {
    let { user: { userId, name, isSystemUser } } = props;
    const { theme } = useMprcTheme();
    const session = useSession();
    const { showUser } = useModalUserProfile();

    if (isSystemUser) {
        return <b><i>{name}</i></b>;
    }

    if (userId == session.user.userId) {
        return <b title={name}>{theme.MprcUserProfileLink.yourselfName}</b>;
    }

    return (
        <MprcLink
            title={name}
            onClick={() => showUser(userId)}
        >
            <b>{LibUtils.firstWord(name)}</b>
        </MprcLink>
    );
};
